import { withTimezoneLabel } from "@utils/datetime";

export enum EmployeeApplicationTableColumns {
  applicationName = "applicationName",
  description = "description",
  category = "category",
  lastUsed = "lastUsed",
}

export const EMPLOYEE_APPLICATION_TABLE_COLUMN_LABELS: Record<
  EmployeeApplicationTableColumns,
  string
> = {
  [EmployeeApplicationTableColumns.applicationName]: "Application",
  [EmployeeApplicationTableColumns.description]: "Description",
  [EmployeeApplicationTableColumns.category]: "Category",
  [EmployeeApplicationTableColumns.lastUsed]: withTimezoneLabel("Last used"),
};

export const DEFAULT_EMPLOYEE_APPLICATION_TABLE_COLUMN_SETTINGS: Record<EmployeeApplicationTableColumns, boolean> = {
  [EmployeeApplicationTableColumns.applicationName]: true,
  [EmployeeApplicationTableColumns.description]: true,
  [EmployeeApplicationTableColumns.category]: true,
  [EmployeeApplicationTableColumns.lastUsed]: true,
};

export const DEFAULT_EMPLOYEE_APPLICATION_TABLE_COLUMN_ORDER: EmployeeApplicationTableColumns[] = [
  EmployeeApplicationTableColumns.applicationName,
  EmployeeApplicationTableColumns.description,
  EmployeeApplicationTableColumns.category,
  EmployeeApplicationTableColumns.lastUsed,
];

// Helper functions to generate derived data
export const getColumnLabels = (): Record<string, string> => EMPLOYEE_APPLICATION_TABLE_COLUMN_LABELS;
export const getDefaultColumnSettings = (): Record<string, boolean> => DEFAULT_EMPLOYEE_APPLICATION_TABLE_COLUMN_SETTINGS;
export const getDefaultColumnOrder = (): string[] => DEFAULT_EMPLOYEE_APPLICATION_TABLE_COLUMN_ORDER;